export default "__VITE_PUBLIC_ASSET__517625a0__"